<apt-dialog title="" modal="true" [(open)]="isPreparingQuote" width="670px" [showCloseX]="false">
  <ng-container dialogBody>
    <apt-waiter
      *ngIf="agentCode == 18089"
      [evaluate]="hasTargetQuoteStatus()"
      [title]="preparingTitle"
      [rollingText]="preparingMessages"
      timeout="120000"
      [rollingWait]="5000"
      [repeat]="false"
      [(timedOut)]="prepareQuoteTimedOut"
      [contactInfo]="emptyContactMsg"
      [error]="preparingError"
      (timedOutChange)="prepareTimeOutChange($event)"
    >
    </apt-waiter>
    <apt-waiter
      *ngIf="agentCode != 18089"
      [evaluate]="hasTargetQuoteStatus()"
      [title]="preparingTitle"
      [rollingText]="preparingMessages"
      timeout="120000"
      [rollingWait]="5000"
      [repeat]="false"
      [(timedOut)]="prepareQuoteTimedOut"
      [error]="preparingError"
      (timedOutChange)="prepareTimeOutChange($event)"
    >
    </apt-waiter>

    <p class="in-progress-refresh-message" *ngIf="!proceedPreQTDUntilBind">
      This page will automatically refresh. Or you can
      <span class="clickable" (click)="refreshOrCheckNow()">click here to refresh now</span>.
    </p>

    <p class="in-progress-refresh-message" *ngIf="proceedPreQTDUntilBind">
      Quote status is being checked automatically. Or you can
      <span class="clickable" (click)="refreshOrCheckNow()">click here to check again now</span>.
    </p>
  </ng-container>
</apt-dialog>
